module.exports = __webpack_public_path__ + "img/gs_bg.ac1850cd.png";